import { gql } from "lib/apolloClient";

export const updateConfigurationMutation = gql`
  mutation setConfigurationValue($input: [ConfigurationValueUpdateInput!]!) {
    platform {
      setMultipleConfigurationValueForEntityGroups(input: $input)
      __typename
    }
  }
`;
